import React, { PureComponent } from 'react';
import Select from 'react-select';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import Upload from 'Components/Upload/index';

class UploadEximTrackingConfirmationPopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {selectedUploadOption, handleUploadSelectChange, handleUploadFile } = this.props;
    const options = [
      { value: '3', label: 'CFS' },
      { value: '2', label: 'NON-SAP Data' },
    ];

    return (
      <div style={{
        background: 'white', padding: '20px', borderRadius: '5px',
        width: '400px'
      }}>
        <br />
        <div style={{
          width: '260px'
        }}>
          Type:
          <Select
            value={selectedUploadOption}
            onChange={handleUploadSelectChange}
            options={options}
            style={{ marginBottom: '15px' }}
          />
        </div>
        <br />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
          <Upload onChange={handleUploadFile} className="mt-25">
            <button
              style={{ padding: '8px 16px', border: 'none', background: '#007BFF', color: 'white', cursor: 'pointer', borderRadius: '3px' }}
            > Continue </button>
          </Upload>
        </div>
      </div>
    );
  }
}

export default UploadEximTrackingConfirmationPopup;
